import { useCallback, useEffect } from 'react';
import { YM } from '@bankiru/core-scripts/yandex-metrika';

export const useYandexMetric = () => {
	useEffect(() => {
		const paramsData = getIdentificatorsParams({});

		YM.params(paramsData);
	}, []);

	const trackYM = useCallback(
		(eventAction: string, eventLabel: string | number = 'null', eventCategory = 'ux_data') => {
			const eventData = getGoalParams({
				eventCategory,
				eventAction,
				eventLabel,
			});

			YM.reachGoal('event_to_ym', eventData);
		},
		[],
	);

	return { trackYM };
};

const getIdentificatorsParams = ({
	cidGa = 0,
	gtmMybId = 0,
	ip = 0,
	userAgent = 0,
	appsflyerId = 0,
	appmetrikaId = 0,
	firebaseId = 0,
	gtmUserId = 0,
}: Record<string, string | number>) => ({
	Идентификаторы: {
		[cidGa]: {
			[gtmMybId]: {
				[ip]: {
					[userAgent]: {
						[appsflyerId]: {
							[appmetrikaId]: {
								[firebaseId]: gtmUserId,
							},
						},
					},
				},
			},
		},
	},
});

type GetGoalParamsProps = {
	eventCategory?: string | number;
	eventAction?: string | number;
	eventLabel?: string | number;
	clientGA?: string | number;
	gtmMybId?: string | number;
	gtmUserId?: number | string;
	href?: string;
};

export const getGoalParams = ({
	eventCategory = 'ux_data',
	eventAction = 0,
	eventLabel = 0,
	clientGA = 0,
	gtmMybId = 0,
	gtmUserId = 0,
}: GetGoalParamsProps) => ({
	События: {
		[eventCategory]: {
			[eventAction]: {
				[eventLabel]: {
					[clientGA]: {
						[gtmMybId]: {
							[gtmUserId]: window.location.href,
						},
					},
				},
			},
		},
	},
});
